// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/task.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { InsightRecommendation } from "./insights";
import { PolicyInstance } from "../../policy/v1/policy";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Form } from "../../form/v1/form";
import { User } from "../../user/v1/user";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Duration } from "../../../../google/protobuf/duration";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Any } from "../../../../google/protobuf/any";
/**
 * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a request where the expand mask is part of the input. Use '*' to view all possible responses.
 *
 * @generated from protobuf message c1.api.task.v1.TaskExpandMask
 */
export interface TaskExpandMask {
    /**
     * A list of paths to expand in the response. May be any combination of "*", "access_review_id", "user_id", "created_by_user_id", "app_id", "app_user_id", "app_entitlement_ids", "step_approver_ids", "approver_ids", "identity_user_id", "insight_ids", and "app_user_last_usage".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetRequest
 */
export interface TaskServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 2
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskServiceGetResponse returns a task view which has a task including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetResponse
 */
export interface TaskServiceGetResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * The TaskServiceCreateGrantResponse returns a task view which has a task including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateGrantResponse
 */
export interface TaskServiceCreateGrantResponse {
    /**
     * A view of the task, of TaskTypeGrant, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * The TaskServiceCreateRevokeResponse returns a task view which has a task including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateRevokeResponse
 */
export interface TaskServiceCreateRevokeResponse {
    /**
     * A view of the task, of TaskTypeRevoke, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateOffboardingResponse
 */
export interface TaskServiceCreateOffboardingResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateActionRequest
 */
export interface TaskServiceCreateActionRequest {
    /**
     * @generated from protobuf field: string action_id = 1
     */
    actionId: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct form_values = 3
     */
    formValues?: Struct;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateActionResponse
 */
export interface TaskServiceCreateActionResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceListRequest
 */
export interface TaskServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceListResponse
 */
export interface TaskServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1
     */
    list: TaskView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceUpdateRequest
 */
export interface TaskServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.task.v1.Task task = 1
     */
    task?: Task;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3
     */
    expandMask?: TaskExpandMask;
}
/**
 * Create a revoke task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateRevokeRequest
 */
export interface TaskServiceCreateRevokeRequest {
    /**
     * The ID of the app associated with the entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement to revoke access to.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the user associated with the app user we are revoking access from. This field cannot be set if appUserID is also set.
     *
     * @generated from protobuf field: string identity_user_id = 6
     */
    identityUserId: string;
    /**
     * The ID of the app user to revoke access from. This field and identityUserId cannot both be set for a given request.
     *
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * The description of the request.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a request where
     * the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 5
     */
    expandMask?: TaskExpandMask;
}
/**
 * Create a grant task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateGrantRequest
 */
export interface TaskServiceCreateGrantRequest {
    /**
     * The ID of the app that is associated with the entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement to grant access to.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the user associated with the app user we are granting access for. This field cannot be set if appUserID is also set.
     *
     * @generated from protobuf field: string identity_user_id = 3
     */
    identityUserId: string;
    /**
     * The ID of the app user to grant access for. This field and identityUserId cannot both be set for a given request.
     *
     * @generated from protobuf field: string app_user_id = 7
     */
    appUserId: string;
    /**
     * The description of the request.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * The duration of the grant.
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 5
     */
    grantDuration?: Duration;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 6
     */
    expandMask?: TaskExpandMask;
    /**
     * Boolean stating whether or not the task is marked as emergency access.
     *
     * @generated from protobuf field: bool emergency_access = 8
     */
    emergencyAccess: boolean;
    /**
     * The source of the grant
     *
     * @generated from protobuf field: c1.api.task.v1.TaskGrantSource source = 9
     */
    source?: TaskGrantSource;
    /**
     * request schema data provided by the user
     *
     * @generated from protobuf field: google.protobuf.Struct request_data = 10
     */
    requestData?: Struct;
}
/**
 * Create multiple grant tasks.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest
 */
export interface TaskServiceCreateManyGrantTasksRequest {
    /**
     * The ID of the app that is associated with the entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The IDs of the app entitlement(s) to grant access to.
     *
     * @generated from protobuf field: repeated string app_entitlement_ids = 2
     */
    appEntitlementIds: string[];
    /**
     * The ID of the user associated with the app user we are granting access for. This field cannot be set if appUserID is also set.
     *
     * @generated from protobuf field: string identity_user_id = 3
     */
    identityUserId: string;
    /**
     * The description of the request.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * The duration of the grant.
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 5
     */
    grantDuration?: Duration;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 6
     */
    expandMask?: TaskExpandMask;
    /**
     * The ID of the app user to grant access for. This field and identityUserId cannot both be set for a given request.
     *
     * @generated from protobuf field: string app_user_id = 7
     */
    appUserId: string;
    /**
     * The source of the grant.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskGrantSource source = 8
     */
    source?: TaskGrantSource;
    /**
     * References to the app entitlements to grant access to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 9
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * Request schema data provided by the user
     *
     * @generated from protobuf field: google.protobuf.Struct request_data = 10
     */
    requestData?: Struct;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateOffboardingRequest
 */
export interface TaskServiceCreateOffboardingRequest {
    /**
     * @generated from protobuf field: string subject_user_id = 1
     */
    subjectUserId: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateRequest
 */
export interface TaskServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskType typ = 5
     */
    typ?: TaskType;
    /**
     * @generated from protobuf field: string description = 6
     */
    description: string;
    /**
     * @generated from protobuf field: string user_id = 7
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 9
     */
    expandMask?: TaskExpandMask;
    /**
     * @generated from protobuf field: bool emergency_access = 10
     */
    emergencyAccess: boolean;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceDeleteRequest
 */
export interface TaskServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskApprovers
 */
export interface TaskApprovers {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User users = 1
     */
    users: User[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest
 */
export interface TaskServiceGetSendReminderPreviewRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse
 */
export interface TaskServiceGetSendReminderPreviewResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskApprovers task_approvers = 1
     */
    taskApprovers?: TaskApprovers;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceSendReminderRequest
 */
export interface TaskServiceSendReminderRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
    /**
     * @generated from protobuf field: bool copy_managers = 2
     */
    copyManagers: boolean;
    /**
     * @generated from protobuf field: string message = 3
     */
    message: string;
    /**
     * @generated from protobuf field: repeated string copied_user_ids = 4
     */
    copiedUserIds: string[];
}
/**
 * Request/Response messages for ResolvedFormDataService
 *
 * @generated from protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest
 */
export interface ResolvedFormDataServiceGetByTaskIdRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse
 */
export interface ResolvedFormDataServiceGetByTaskIdResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.ResolvedFormData resolved_form_data = 1
     */
    resolvedFormData?: ResolvedFormData;
}
/**
 * ResolvedFormData contains the form schema and resolved values for a task.
 *
 * @generated from protobuf message c1.api.task.v1.ResolvedFormData
 */
export interface ResolvedFormData {
    /**
     * The form schema captured at submission time.
     *
     * @generated from protobuf field: c1.api.form.v1.Form form = 1
     */
    form?: Form;
    /**
     * Resolved values computed at submission time, used for both execution and display.
     *
     * @generated from protobuf field: google.protobuf.Struct resolved_values = 2
     */
    resolvedValues?: Struct;
    /**
     * Timestamp when the resolved form data was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * Timestamp when the resolved form data was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * Timestamp when the resolved form data was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceSendReminderResponse
 */
export interface TaskServiceSendReminderResponse {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceDeleteResponse
 */
export interface TaskServiceDeleteResponse {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
}
/**
 * Task Type provides configuration for the type of task: certify, grant, or revoke
 *
 * @generated from protobuf message c1.api.task.v1.TaskType
 */
export interface TaskType {
    /**
     * @generated from protobuf oneof: task_type
     */
    taskType: {
        oneofKind: "grant";
        /**
         * A sub-object indicating the ticket is of type Grant. Mutually exclusive with certify and revoke properties.
         *
         * @generated from protobuf field: c1.api.task.v1.TaskTypeGrant grant = 1
         */
        grant: TaskTypeGrant;
    } | {
        oneofKind: "revoke";
        /**
         * A sub-object indicating the ticket is of type Revoke. Mutually exclusive with certify and grant properties.
         *
         * @generated from protobuf field: c1.api.task.v1.TaskTypeRevoke revoke = 2
         */
        revoke: TaskTypeRevoke;
    } | {
        oneofKind: "certify";
        /**
         * A sub-object indicating the ticket is of type Certify. Mutually exclusive with grant and revoke properties.
         *
         * @generated from protobuf field: c1.api.task.v1.TaskTypeCertify certify = 3
         */
        certify: TaskTypeCertify;
    } | {
        oneofKind: "offboarding";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskTypeOffboarding offboarding = 4
         */
        offboarding: TaskTypeOffboarding;
    } | {
        oneofKind: "action";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskTypeAction action = 5
         */
        action: TaskTypeAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskTypeAction
 */
export interface TaskTypeAction {
    /**
     * The ID of the action to execute.
     *
     * @generated from protobuf field: string action_id = 1
     */
    actionId: string;
    /**
     * The form values for the action execution.
     *
     * @generated from protobuf field: google.protobuf.Struct form_values = 2
     */
    formValues?: Struct;
    /**
     * @generated from protobuf field: c1.api.task.v1.ActionOutcome outcome = 3
     */
    outcome: ActionOutcome;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 4
     */
    outcomeTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskTypeOffboarding
 */
export interface TaskTypeOffboarding {
    /**
     * @generated from protobuf field: string subject_user_id = 1
     */
    subjectUserId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.OffboardingOutcome outcome = 2
     */
    outcome: OffboardingOutcome;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 3
     */
    outcomeTime?: Timestamp;
}
/**
 * The TaskTypeGrant message indicates that a task is a grant task and all related details.
 *
 * @generated from protobuf message c1.api.task.v1.TaskTypeGrant
 */
export interface TaskTypeGrant {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * The ID of the app entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * The duration of the grant.
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 4
     */
    grantDuration?: Duration;
    /**
     * The outcome of the grant.
     *
     * @generated from protobuf field: c1.api.task.v1.GrantOutcome outcome = 5
     */
    outcome: GrantOutcome;
    /**
     * The time of the outcome of the grant.
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 6
     */
    outcomeTime?: Timestamp;
    /**
     * The ID of the user.
     *
     * @generated from protobuf field: string identity_user_id = 7
     */
    identityUserId: string;
    /**
     * The source of the grant.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskGrantSource source = 8
     */
    source?: TaskGrantSource;
}
/**
 * The TaskGrantSource message tracks which external URL was the source of the specificed grant ticket.
 *
 * @generated from protobuf message c1.api.task.v1.TaskGrantSource
 */
export interface TaskGrantSource {
    /**
     * The integration id for the source of tickets.
     *
     * @generated from protobuf field: string integration_id = 1
     */
    integrationId: string;
    /**
     * The external url source of the grant ticket.
     *
     * @generated from protobuf field: string external_url = 2
     */
    externalUrl: string;
    /**
     * the request id for the grant ticket if the source is external
     *
     * @generated from protobuf field: string request_id = 3
     */
    requestId: string;
    /**
     * The ID of the conversation that created this ticket
     *
     * @generated from protobuf field: string conversation_id = 4
     */
    conversationId: string;
    /**
     * Whether the grant task is an extension task.
     *
     * @generated from protobuf field: bool is_extension = 5
     */
    isExtension: boolean;
}
/**
 * The TaskRevokeSourceReview message tracks which access review was the source of the specificed revoke ticket.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceReview
 */
export interface TaskRevokeSourceReview {
    /**
     * The ID of the access review associated with the revoke task.
     *
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * The ID of the certify ticket that was denied and created this revoke task.
     *
     * @generated from protobuf field: string cert_ticket_id = 2
     */
    certTicketId: string;
}
/**
 * The TaskRevokeSourceRequest message indicates that the source of the revoke task was a request.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceRequest
 */
export interface TaskRevokeSourceRequest {
    /**
     * The ID of the user who initiated the revoke request.
     *
     * @generated from protobuf field: string request_user_id = 1
     */
    requestUserId: string;
}
/**
 * The TaskRevokeSourceExpired message indicates that the source of the revoke task is due to a grant expiring.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceExpired
 */
export interface TaskRevokeSourceExpired {
    /**
     * The timestamp indicates when the grant expired, automatically creating this revoke task.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expired_at = 1
     */
    expiredAt?: Timestamp;
}
/**
 * The TaskRevokeSourceNonUsage message indicates that the source of the revoke task is due to the grant not being used.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceNonUsage
 */
export interface TaskRevokeSourceNonUsage {
    /**
     * The timestamp indicates when the revoke task will automatically happen.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 1
     */
    expiresAt?: Timestamp;
    /**
     * The timestamp of the user's last login, due to non usage this task was automatically created
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_login = 2
     */
    lastLogin?: Timestamp;
}
/**
 * The TaskRevokeSource message indicates the source of the revoke task is one of expired, nonUsage, request, or review.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSource
 */
export interface TaskRevokeSource {
    /**
     * @generated from protobuf oneof: origin
     */
    origin: {
        oneofKind: "review";
        /**
         * Source of the revoke is a review
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceReview review = 1
         */
        review: TaskRevokeSourceReview;
    } | {
        oneofKind: "request";
        /**
         * Source of the revoke is a request
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceRequest request = 2
         */
        request: TaskRevokeSourceRequest;
    } | {
        oneofKind: "expired";
        /**
         * Source of the revoke is the grant has expired (auto created)
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceExpired expired = 3
         */
        expired: TaskRevokeSourceExpired;
    } | {
        oneofKind: "nonUsage";
        /**
         * Source of the revoke is due to inactivity (auto created due to user inactivity)
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceNonUsage non_usage = 4
         */
        nonUsage: TaskRevokeSourceNonUsage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * The TaskTypeRevoke message indicates that a task is a revoke task and all related details.
 *
 * @generated from protobuf message c1.api.task.v1.TaskTypeRevoke
 */
export interface TaskTypeRevoke {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 5
     */
    appUserId: string;
    /**
     * The ID of the app entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The outcome of the revoke.
     *
     * @generated from protobuf field: c1.api.task.v1.RevokeOutcome outcome = 3
     */
    outcome: RevokeOutcome;
    /**
     * The time (in RFC3339 format) of the outcome of the revoke
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 4
     */
    outcomeTime?: Timestamp;
    /**
     * The ID of the user.
     *
     * @generated from protobuf field: string identity_user_id = 6
     */
    identityUserId: string;
    /**
     * The source of the revoke.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskRevokeSource source = 7
     */
    source?: TaskRevokeSource;
}
/**
 * The TaskTypeCertify message indicates that a task is a certify task and all related details.
 *
 * @generated from protobuf message c1.api.task.v1.TaskTypeCertify
 */
export interface TaskTypeCertify {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the access review.
     *
     * @generated from protobuf field: string access_review_id = 3
     */
    accessReviewId: string;
    /**
     * The ID of the specific access review object that owns this certify task. This is also set on a revoke task if the revoke task is created from the denied outcome of a certify task.
     *
     * @generated from protobuf field: string access_review_selection = 4
     */
    accessReviewSelection: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 5
     */
    appUserId: string;
    /**
     * The outcome of the certification.
     *
     * @generated from protobuf field: c1.api.task.v1.CertifyOutcome outcome = 6
     */
    outcome: CertifyOutcome;
    /**
     * The timestamp indicating when the certification outcome occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 7
     */
    outcomeTime?: Timestamp;
    /**
     * The ID of the user.
     *
     * @generated from protobuf field: string identity_user_id = 8
     */
    identityUserId: string;
}
/**
 * A reference to an external source. This value is unused currently, but may be brought back.
 *
 * @generated from protobuf message c1.api.task.v1.ExternalRef
 */
export interface ExternalRef {
    /**
     * The URL to the external reference.
     *
     * @generated from protobuf field: string url = 1
     */
    url: string;
    /**
     * The name of the external reference.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * The source of the external reference.
     *
     * @generated from protobuf field: c1.api.task.v1.ExternalRefSource external_ref_source = 3
     */
    externalRefSource: ExternalRefSource;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskWebhookPayload
 */
export interface TaskWebhookPayload {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * Contains a task and JSONPATH expressions that describe where in the expanded array related objects are located. This view can be used to display a fully-detailed dashboard of task information.
 *
 * @generated from protobuf message c1.api.task.v1.TaskView
 */
export interface TaskView {
    /**
     * The task object being returned by the request.
     *
     * @generated from protobuf field: c1.api.task.v1.Task task = 1
     */
    task?: Task;
    /**
     * JSONPATH expression indicating the location of the User object in the expanded array. This is the user that is a direct target of the ticket without a specific relationship to a potentially non-existent app user.
     *
     * @generated from protobuf field: string user_path = 2
     */
    userPath: string;
    /**
     * JSONPATH expression indicating the location of the object of the User that created the ticket in the expanded array
     *
     * @generated from protobuf field: string created_by_user_path = 3
     */
    createdByUserPath: string;
    /**
     * JSONPATH expression indicating the location of the App object in the expanded array
     *
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the Entitlements objects in the expanded array
     *
     * @generated from protobuf field: string entitlements_path = 5
     */
    entitlementsPath: string;
    /**
     * JSONPATH expression indicating the location of the AccessReview object in the expanded array
     *
     * @generated from protobuf field: string access_review_path = 6
     */
    accessReviewPath: string;
    /**
     * JSONPATH expression indicating the location of the AppUser object in the expanded array
     *
     * @generated from protobuf field: string app_user_path = 7
     */
    appUserPath: string;
    /**
     * JSONPATH expression indicating the location of the StepApproverUsers objects in the expanded array
     *
     * @generated from protobuf field: string step_approvers_path = 8
     */
    stepApproversPath: string;
    /**
     * JSONPATH expression indicating the location of the User object of the User that this task is targeting in the expanded array. This is the user that is the identity when the target of a task is an app user.
     *
     * @generated from protobuf field: string identity_user_path = 9
     */
    identityUserPath: string;
    /**
     * JSONPATH expression indicating the location of the ApproverUsers objects in the expanded array. These are the users who have approved or denied this task.
     *
     * @generated from protobuf field: string approvers_path = 12;
     */
    approversPath: string;
    /**
     * JSONPATH expression indicating the location of the Insights objects in the expanded array
     *
     * @generated from protobuf field: string insights_path = 10
     */
    insightsPath: string;
    /**
     * JSONPATH expression indicating the location of the AppUser last usage timestamp in the expanded array
     *
     * @generated from protobuf field: string app_user_last_usage_path = 11
     */
    appUserLastUsagePath: string;
}
/**
 * This object references a task by ID.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRef
 */
export interface TaskRef {
    /**
     * The ID of the referenced Task
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.GrantOrRevokeTaskRef
 */
export interface GrantOrRevokeTaskRef {
    /**
     * The ID of the referenced Task
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * A message to update the task counts.
 *
 * @generated from protobuf message c1.api.task.v1.TaskCountRefreshRef
 */
export interface TaskCountRefreshRef {
}
/**
 * A fully-fleged task object. Includes its policy, references to external apps, its type, its processing history, and more.
 *
 * @generated from protobuf message c1.api.task.v1.Task
 */
export interface Task {
    /**
     * The ID of the task.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The display name of the task.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * The description of the task. This is also known as justification.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * The ID of the user that is the target of this task. This may be empty if we're targeting a specific app user that has no known identity user.
     *
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
    /**
     * The ID of the user that is the creator of this task. This may not always match the userId field.
     *
     * @generated from protobuf field: string created_by_user_id = 5
     */
    createdByUserId: string;
    /**
     * The current state of the task as defined by the `state_enum`
     *
     * @generated from protobuf field: c1.api.task.v1.TaskState state = 6
     */
    state: TaskState;
    /**
     * The datetime, in RFC3339 format, of when the Task was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Task was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 18
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Task was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 19
     */
    deletedAt?: Timestamp;
    /**
     * This is a oneOf of Task Type. Only one of TaskType's sub-properties will be non-null at a time.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskType type = 9
     */
    type?: TaskType;
    /**
     * A fully-qualified PolicyInstance object defining the previous, current, and future processing steps of a task.
     *
     * @generated from protobuf field: c1.api.policy.v1.PolicyInstance policy = 10
     */
    policy?: PolicyInstance;
    /**
     * The actions that can be performed on the task by the current user.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskActionType actions = 11
     */
    actions: TaskActionType[];
    /**
     * An array of external references to the task. Historically that has been items like Jira task IDs. This is currently unused, but may come back in the future for integrations.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.ExternalRef external_refs = 12
     */
    externalRefs: ExternalRef[];
    /**
     * An array of `google.protobuf.Any` annotations with various base64-encoded data.
     *
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 13
     */
    annotations: Any[];
    /**
     * The ID of the analysis object associated with this task created by an analysis workflow if the analysis feature is enabled for your tenant.
     *
     * @generated from protobuf field: string analysis_id = 14
     */
    analysisId: string;
    /**
     * An array of IDs belonging to Identity Users that are allowed to review this step in a task.
     *
     * @generated from protobuf field: repeated string step_approver_ids = 15
     */
    stepApproverIds: string[];
    /**
     * An array of IDs belonging to Identity Users that have approved or denied any step in this task.
     *
     * @generated from protobuf field: repeated string approver_ids = 28;
     */
    approverIds: string[];
    /**
     * The count of comments.
     *
     * @generated from protobuf field: int32 comment_count = 16
     */
    commentCount: number;
    /**
     * A human-usable numeric ID of a task which can be included in place of the fully qualified task id in path parmeters (but not search queries).
     *
     * @generated from protobuf field: int64 numeric_id = 17
     */
    numericId: number;
    /**
     * The processing state of a task as defined by the `processing_enum`
     *
     * @generated from protobuf field: c1.api.task.v1.TaskProcessingType processing = 20
     */
    processing: TaskProcessingType;
    /**
     * A field indicating whether this task was created using an emergency access flow, or escalated to emergency access. On task creation, it will also use the app entitlement's emergency policy when possible.
     *
     * @generated from protobuf field: bool emergency_access = 21
     */
    emergencyAccess: boolean;
    /**
     * The policy generation id refers to the current policy's generation ID. This is changed when the policy is changed on a task.
     *
     * @generated from protobuf field: string policy_generation_id = 22
     */
    policyGenerationId: string;
    /**
     * @generated from protobuf field: repeated string insight_ids = 23
     */
    insightIds: string[];
    /**
     * @generated from protobuf field: c1.api.task.v1.InsightRecommendation recommendation = 24
     */
    recommendation: InsightRecommendation;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskOrigin origin = 25
     */
    origin: TaskOrigin;
    /**
     * for custom form user input
     *
     * @generated from protobuf field: c1.api.form.v1.Form form = 26
     */
    form?: Form;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 27
     */
    data?: Struct;
}
/**
 * @generated from protobuf message c1.api.task.v1.ListByUserRequest
 */
export interface ListByUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.RestartTaskWorkflowRequest
 */
export interface RestartTaskWorkflowRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.RestartTaskWorkflowResponse
 */
export interface RestartTaskWorkflowResponse {
}
/**
 * @generated from protobuf enum c1.api.task.v1.ActionOutcome
 */
export enum ActionOutcome {
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.OffboardingOutcome
 */
export enum OffboardingOutcome {
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_DONE = 2;
     */
    DONE = 2,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.GrantOutcome
 */
export enum GrantOutcome {
    /**
     * Unspecified task grant outcome, this is the default value.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The outcome if the grant was successful.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_GRANTED = 1;
     */
    GRANTED = 1,
    /**
     * The outcome if the grant was denied.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * The outcome if the grant encountered an error.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * The outcome if the grant was cancelled.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4,
    /**
     * The outcome if a wait step timed out.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_WAIT_TIMED_OUT = 5;
     */
    WAIT_TIMED_OUT = 5
}
/**
 * @generated from protobuf enum c1.api.task.v1.RevokeOutcome
 */
export enum RevokeOutcome {
    /**
     * Unspecified revoke outcome, this is the default outcome
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The outcome if the revoke was successful
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_REVOKED = 1;
     */
    REVOKED = 1,
    /**
     * The outcome if the revoke was denied
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * The outcome if the revoke encountered an error
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * The outcome if the revoke was cancelled
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4,
    /**
     * The outcome if a wait step timed out.
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_WAIT_TIMED_OUT = 5;
     */
    WAIT_TIMED_OUT = 5
}
/**
 * @generated from protobuf enum c1.api.task.v1.CertifyOutcome
 */
export enum CertifyOutcome {
    /**
     * Unspecified certify outcome, this is the default value.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The task was successfully certified.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_CERTIFIED = 1;
     */
    CERTIFIED = 1,
    /**
     * The certification denied, causing a decertified state. This may result in a revoke task being created or a reminder being set out, depending on the access review configurations. See (certifyRemediateImmediately).
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_DECERTIFIED = 2;
     */
    DECERTIFIED = 2,
    /**
     * An error occurred during the certification process.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * The certification request was canceled.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4,
    /**
     * The outcome if a wait step timed out.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_WAIT_TIMED_OUT = 5;
     */
    WAIT_TIMED_OUT = 5
}
/**
 * @generated from protobuf enum c1.api.task.v1.AccessRequestOutcome
 */
export enum AccessRequestOutcome {
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_APPROVED = 1;
     */
    APPROVED = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.ExternalRefSource
 */
export enum ExternalRefSource {
    /**
     * Unspecified external reference source, this is the default value.
     *
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The external reference source was a JIRA ticket.
     *
     * @generated from protobuf enum value: JIRA = 1;
     */
    JIRA = 1
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskOrigin
 */
export enum TaskOrigin {
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_PROFILE_MEMBERSHIP_AUTOMATION = 1;
     */
    PROFILE_MEMBERSHIP_AUTOMATION = 1,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_SLACK = 2;
     */
    SLACK = 2,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_API = 3;
     */
    API = 3,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_JIRA = 4;
     */
    JIRA = 4,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_COPILOT = 5;
     */
    COPILOT = 5,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_WEBAPP = 6;
     */
    WEBAPP = 6,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_TIME_REVOKE = 7;
     */
    TIME_REVOKE = 7,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_NON_USAGE_REVOKE = 8;
     */
    NON_USAGE_REVOKE = 8,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_PROFILE_MEMBERSHIP_MANUAL = 9;
     */
    PROFILE_MEMBERSHIP_MANUAL = 9,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_PROFILE_MEMBERSHIP = 10;
     */
    PROFILE_MEMBERSHIP = 10,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_AUTOMATION = 11;
     */
    AUTOMATION = 11,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_ACCESS_REVIEW = 12;
     */
    ACCESS_REVIEW = 12,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_CASCADE_DELETE = 13;
     */
    CASCADE_DELETE = 13
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskState
 */
export enum TaskState {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: TASK_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The state of the task while it is open.
     *
     * @generated from protobuf enum value: TASK_STATE_OPEN = 1;
     */
    OPEN = 1,
    /**
     * The state of the task while it is closed.
     *
     * @generated from protobuf enum value: TASK_STATE_CLOSED = 2;
     */
    CLOSED = 2
}
/**
 * These two items are in this file because we can't have circular dependencies
 *
 * @generated from protobuf enum c1.api.task.v1.TaskActionState
 */
export enum TaskActionState {
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_DONE = 2;
     */
    DONE = 2,
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_ERROR = 3;
     */
    ERROR = 3
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskActionType
 */
export enum TaskActionType {
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_CLOSE = 1;
     */
    CLOSE = 1,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_APPROVE = 2;
     */
    APPROVE = 2,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_DENY = 3;
     */
    DENY = 3,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_COMMENT = 4;
     */
    COMMENT = 4,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_DELETE = 5;
     */
    DELETE = 5,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_REASSIGN = 6;
     */
    REASSIGN = 6,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_RESTART = 7;
     */
    RESTART = 7,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SEND_REMINDER = 8;
     */
    SEND_REMINDER = 8,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_COMPLETE = 9;
     */
    PROVISION_COMPLETE = 9,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_CANCELLED = 10;
     */
    PROVISION_CANCELLED = 10,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_ERRORED = 11;
     */
    PROVISION_ERRORED = 11,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_ROLLBACK_SKIPPED = 12;
     */
    ROLLBACK_SKIPPED = 12,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_APP_USER_TARGET_CREATED = 13;
     */
    PROVISION_APP_USER_TARGET_CREATED = 13,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_HARD_RESET = 14;
     */
    HARD_RESET = 14,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_ESCALATE_TO_EMERGENCY_ACCESS = 15;
     */
    ESCALATE_TO_EMERGENCY_ACCESS = 15,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_CHANGE_POLICY = 16;
     */
    CHANGE_POLICY = 16,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_RECALCULATE_DENIAL_FROM_BASE_POLICY_DECISIONS = 17;
     */
    RECALCULATE_DENIAL_FROM_BASE_POLICY_DECISIONS = 17,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SET_INSIGHTS_AND_RECOMMENDATION = 18;
     */
    SET_INSIGHTS_AND_RECOMMENDATION = 18,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SET_ANALYSIS_ID = 19;
     */
    SET_ANALYSIS_ID = 19,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_RECALCULATE_APPROVERS_LIST = 20;
     */
    RECALCULATE_APPROVERS_LIST = 20,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROCESS_NOW = 21;
     */
    PROCESS_NOW = 21,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_APPROVE_WITH_STEP_UP = 22;
     */
    APPROVE_WITH_STEP_UP = 22,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SKIP_STEP = 23;
     */
    SKIP_STEP = 23,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_ROLLBACK_CANCELLED = 24;
     */
    ROLLBACK_CANCELLED = 24,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_UPDATE_REQUEST_DATA = 25;
     */
    UPDATE_REQUEST_DATA = 25,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_UPDATE_GRANT_DURATION = 26;
     */
    UPDATE_GRANT_DURATION = 26
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskProcessingType
 */
export enum TaskProcessingType {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * A calculated field based on task states for when a task is processing.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_PROCESSING = 1;
     */
    PROCESSING = 1,
    /**
     * A calculated field based on task states for when a task is waiting for input.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_WAITING = 2;
     */
    WAITING = 2,
    /**
     * A calculated field based on task states for when a task has finished processing.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_DONE = 3;
     */
    DONE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskExpandMask$Type extends MessageType<TaskExpandMask> {
    constructor() {
        super("c1.api.task.v1.TaskExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "access_review_id", "user_id", "created_by_user_id", "app_id", "app_user_id", "app_entitlement_ids", "step_approver_ids", "approver_ids", "identity_user_id", "insight_ids", "app_user_last_usage"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<TaskExpandMask>): TaskExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<TaskExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskExpandMask): TaskExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskExpandMask
 */
export const TaskExpandMask = new TaskExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetRequest$Type extends MessageType<TaskServiceGetRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})|([0-9]+)$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskServiceGetRequest>): TaskServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceGetRequest): TaskServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 2:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 2; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetRequest
 */
export const TaskServiceGetRequest = new TaskServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetResponse$Type extends MessageType<TaskServiceGetResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceGetResponse>): TaskServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceGetResponse): TaskServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task_view */ 1:
                    message.taskView = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.taskView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task_view = 1; */
        if (message.taskView)
            TaskView.internalBinaryWrite(message.taskView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetResponse
 */
export const TaskServiceGetResponse = new TaskServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateGrantResponse$Type extends MessageType<TaskServiceCreateGrantResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateGrantResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateGrantResponse>): TaskServiceCreateGrantResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateGrantResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateGrantResponse): TaskServiceCreateGrantResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task_view */ 1:
                    message.taskView = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.taskView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateGrantResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task_view = 1; */
        if (message.taskView)
            TaskView.internalBinaryWrite(message.taskView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateGrantResponse
 */
export const TaskServiceCreateGrantResponse = new TaskServiceCreateGrantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateRevokeResponse$Type extends MessageType<TaskServiceCreateRevokeResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateRevokeResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateRevokeResponse>): TaskServiceCreateRevokeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateRevokeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateRevokeResponse): TaskServiceCreateRevokeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task_view */ 1:
                    message.taskView = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.taskView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateRevokeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task_view = 1; */
        if (message.taskView)
            TaskView.internalBinaryWrite(message.taskView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateRevokeResponse
 */
export const TaskServiceCreateRevokeResponse = new TaskServiceCreateRevokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateOffboardingResponse$Type extends MessageType<TaskServiceCreateOffboardingResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateOffboardingResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateOffboardingResponse>): TaskServiceCreateOffboardingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateOffboardingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateOffboardingResponse): TaskServiceCreateOffboardingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task_view */ 1:
                    message.taskView = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.taskView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateOffboardingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task_view = 1; */
        if (message.taskView)
            TaskView.internalBinaryWrite(message.taskView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateOffboardingResponse
 */
export const TaskServiceCreateOffboardingResponse = new TaskServiceCreateOffboardingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateActionRequest$Type extends MessageType<TaskServiceCreateActionRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateActionRequest", [
            { no: 1, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "form_values", kind: "message", T: () => Struct },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateActionRequest>): TaskServiceCreateActionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actionId = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateActionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateActionRequest): TaskServiceCreateActionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string action_id */ 1:
                    message.actionId = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Struct form_values */ 3:
                    message.formValues = Struct.internalBinaryRead(reader, reader.uint32(), options, message.formValues);
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 4:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateActionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string action_id = 1; */
        if (message.actionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actionId);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Struct form_values = 3; */
        if (message.formValues)
            Struct.internalBinaryWrite(message.formValues, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskExpandMask expand_mask = 4; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateActionRequest
 */
export const TaskServiceCreateActionRequest = new TaskServiceCreateActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateActionResponse$Type extends MessageType<TaskServiceCreateActionResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateActionResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateActionResponse>): TaskServiceCreateActionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateActionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateActionResponse): TaskServiceCreateActionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task_view */ 1:
                    message.taskView = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.taskView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateActionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task_view = 1; */
        if (message.taskView)
            TaskView.internalBinaryWrite(message.taskView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateActionResponse
 */
export const TaskServiceCreateActionResponse = new TaskServiceCreateActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceListRequest$Type extends MessageType<TaskServiceListRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskServiceListRequest>): TaskServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceListRequest): TaskServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 3:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 3; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceListRequest
 */
export const TaskServiceListRequest = new TaskServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceListResponse$Type extends MessageType<TaskServiceListResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskServiceListResponse>): TaskServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceListResponse): TaskServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView list */ 1:
                    message.list.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceListResponse
 */
export const TaskServiceListResponse = new TaskServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceUpdateRequest$Type extends MessageType<TaskServiceUpdateRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceUpdateRequest", [
            { no: 1, name: "task", kind: "message", T: () => Task, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskServiceUpdateRequest>): TaskServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceUpdateRequest): TaskServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.Task task */ 1:
                    message.task = Task.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 3:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.Task task = 1; */
        if (message.task)
            Task.internalBinaryWrite(message.task, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskExpandMask expand_mask = 3; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceUpdateRequest
 */
export const TaskServiceUpdateRequest = new TaskServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateRevokeRequest$Type extends MessageType<TaskServiceCreateRevokeRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateRevokeRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateRevokeRequest>): TaskServiceCreateRevokeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.identityUserId = "";
        message.appUserId = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateRevokeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateRevokeRequest): TaskServiceCreateRevokeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string identity_user_id */ 6:
                    message.identityUserId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 5:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateRevokeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 5; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_id = 6; */
        if (message.identityUserId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.identityUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateRevokeRequest
 */
export const TaskServiceCreateRevokeRequest = new TaskServiceCreateRevokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateGrantRequest$Type extends MessageType<TaskServiceCreateGrantRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateGrantRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 7, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "grant_duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { gt: {} } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 8, name: "emergency_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "source", kind: "message", T: () => TaskGrantSource },
            { no: 10, name: "request_data", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateGrantRequest>): TaskServiceCreateGrantRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.identityUserId = "";
        message.appUserId = "";
        message.description = "";
        message.emergencyAccess = false;
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateGrantRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateGrantRequest): TaskServiceCreateGrantRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string identity_user_id */ 3:
                    message.identityUserId = reader.string();
                    break;
                case /* string app_user_id */ 7:
                    message.appUserId = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration grant_duration */ 5:
                    message.grantDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.grantDuration);
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 6:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool emergency_access */ 8:
                    message.emergencyAccess = reader.bool();
                    break;
                case /* c1.api.task.v1.TaskGrantSource source */ 9:
                    message.source = TaskGrantSource.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* google.protobuf.Struct request_data */ 10:
                    message.requestData = Struct.internalBinaryRead(reader, reader.uint32(), options, message.requestData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateGrantRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string identity_user_id = 3; */
        if (message.identityUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identityUserId);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration grant_duration = 5; */
        if (message.grantDuration)
            Duration.internalBinaryWrite(message.grantDuration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskExpandMask expand_mask = 6; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_id = 7; */
        if (message.appUserId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appUserId);
        /* bool emergency_access = 8; */
        if (message.emergencyAccess !== false)
            writer.tag(8, WireType.Varint).bool(message.emergencyAccess);
        /* c1.api.task.v1.TaskGrantSource source = 9; */
        if (message.source)
            TaskGrantSource.internalBinaryWrite(message.source, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct request_data = 10; */
        if (message.requestData)
            Struct.internalBinaryWrite(message.requestData, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateGrantRequest
 */
export const TaskServiceCreateGrantRequest = new TaskServiceCreateGrantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateManyGrantTasksRequest$Type extends MessageType<TaskServiceCreateManyGrantTasksRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "grant_duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { gt: {} } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 7, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 8, name: "source", kind: "message", T: () => TaskGrantSource },
            { no: 9, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 10, name: "request_data", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateManyGrantTasksRequest>): TaskServiceCreateManyGrantTasksRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementIds = [];
        message.identityUserId = "";
        message.description = "";
        message.appUserId = "";
        message.appEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateManyGrantTasksRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateManyGrantTasksRequest): TaskServiceCreateManyGrantTasksRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* repeated string app_entitlement_ids */ 2:
                    message.appEntitlementIds.push(reader.string());
                    break;
                case /* string identity_user_id */ 3:
                    message.identityUserId = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration grant_duration */ 5:
                    message.grantDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.grantDuration);
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 6:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string app_user_id */ 7:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskGrantSource source */ 8:
                    message.source = TaskGrantSource.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 9:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Struct request_data */ 10:
                    message.requestData = Struct.internalBinaryRead(reader, reader.uint32(), options, message.requestData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateManyGrantTasksRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* repeated string app_entitlement_ids = 2; */
        for (let i = 0; i < message.appEntitlementIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementIds[i]);
        /* string identity_user_id = 3; */
        if (message.identityUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identityUserId);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration grant_duration = 5; */
        if (message.grantDuration)
            Duration.internalBinaryWrite(message.grantDuration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskExpandMask expand_mask = 6; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_id = 7; */
        if (message.appUserId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.task.v1.TaskGrantSource source = 8; */
        if (message.source)
            TaskGrantSource.internalBinaryWrite(message.source, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 9; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct request_data = 10; */
        if (message.requestData)
            Struct.internalBinaryWrite(message.requestData, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest
 */
export const TaskServiceCreateManyGrantTasksRequest = new TaskServiceCreateManyGrantTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateOffboardingRequest$Type extends MessageType<TaskServiceCreateOffboardingRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateOffboardingRequest", [
            { no: 1, name: "subject_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateOffboardingRequest>): TaskServiceCreateOffboardingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subjectUserId = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateOffboardingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateOffboardingRequest): TaskServiceCreateOffboardingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject_user_id */ 1:
                    message.subjectUserId = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 3:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateOffboardingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject_user_id = 1; */
        if (message.subjectUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subjectUserId);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 3; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateOffboardingRequest
 */
export const TaskServiceCreateOffboardingRequest = new TaskServiceCreateOffboardingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateRequest$Type extends MessageType<TaskServiceCreateRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 5, name: "typ", kind: "message", T: () => TaskType },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 9, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 10, name: "emergency_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TaskServiceCreateRequest>): TaskServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.description = "";
        message.userId = "";
        message.emergencyAccess = false;
        if (value !== undefined)
            reflectionMergePartial<TaskServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceCreateRequest): TaskServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskType typ */ 5:
                    message.typ = TaskType.internalBinaryRead(reader, reader.uint32(), options, message.typ);
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* string user_id */ 7:
                    message.userId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 9:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool emergency_access */ 10:
                    message.emergencyAccess = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.task.v1.TaskType typ = 5; */
        if (message.typ)
            TaskType.internalBinaryWrite(message.typ, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* string user_id = 7; */
        if (message.userId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userId);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 9; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool emergency_access = 10; */
        if (message.emergencyAccess !== false)
            writer.tag(10, WireType.Varint).bool(message.emergencyAccess);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateRequest
 */
export const TaskServiceCreateRequest = new TaskServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceDeleteRequest$Type extends MessageType<TaskServiceDeleteRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceDeleteRequest>): TaskServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceDeleteRequest): TaskServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceDeleteRequest
 */
export const TaskServiceDeleteRequest = new TaskServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskApprovers$Type extends MessageType<TaskApprovers> {
    constructor() {
        super("c1.api.task.v1.TaskApprovers", [
            { no: 1, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<TaskApprovers>): TaskApprovers {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial<TaskApprovers>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskApprovers): TaskApprovers {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User users */ 1:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskApprovers, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskApprovers
 */
export const TaskApprovers = new TaskApprovers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetSendReminderPreviewRequest$Type extends MessageType<TaskServiceGetSendReminderPreviewRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceGetSendReminderPreviewRequest>): TaskServiceGetSendReminderPreviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceGetSendReminderPreviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceGetSendReminderPreviewRequest): TaskServiceGetSendReminderPreviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceGetSendReminderPreviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest
 */
export const TaskServiceGetSendReminderPreviewRequest = new TaskServiceGetSendReminderPreviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetSendReminderPreviewResponse$Type extends MessageType<TaskServiceGetSendReminderPreviewResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse", [
            { no: 1, name: "task_approvers", kind: "message", T: () => TaskApprovers }
        ]);
    }
    create(value?: PartialMessage<TaskServiceGetSendReminderPreviewResponse>): TaskServiceGetSendReminderPreviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskServiceGetSendReminderPreviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceGetSendReminderPreviewResponse): TaskServiceGetSendReminderPreviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskApprovers task_approvers */ 1:
                    message.taskApprovers = TaskApprovers.internalBinaryRead(reader, reader.uint32(), options, message.taskApprovers);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceGetSendReminderPreviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskApprovers task_approvers = 1; */
        if (message.taskApprovers)
            TaskApprovers.internalBinaryWrite(message.taskApprovers, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse
 */
export const TaskServiceGetSendReminderPreviewResponse = new TaskServiceGetSendReminderPreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceSendReminderRequest$Type extends MessageType<TaskServiceSendReminderRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceSendReminderRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "copy_managers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "copied_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<TaskServiceSendReminderRequest>): TaskServiceSendReminderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        message.copyManagers = false;
        message.message = "";
        message.copiedUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<TaskServiceSendReminderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceSendReminderRequest): TaskServiceSendReminderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                case /* bool copy_managers */ 2:
                    message.copyManagers = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* repeated string copied_user_ids */ 4:
                    message.copiedUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceSendReminderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        /* bool copy_managers = 2; */
        if (message.copyManagers !== false)
            writer.tag(2, WireType.Varint).bool(message.copyManagers);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* repeated string copied_user_ids = 4; */
        for (let i = 0; i < message.copiedUserIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.copiedUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceSendReminderRequest
 */
export const TaskServiceSendReminderRequest = new TaskServiceSendReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFormDataServiceGetByTaskIdRequest$Type extends MessageType<ResolvedFormDataServiceGetByTaskIdRequest> {
    constructor() {
        super("c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})|([0-9]+)$" } } } }
        ]);
    }
    create(value?: PartialMessage<ResolvedFormDataServiceGetByTaskIdRequest>): ResolvedFormDataServiceGetByTaskIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        if (value !== undefined)
            reflectionMergePartial<ResolvedFormDataServiceGetByTaskIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolvedFormDataServiceGetByTaskIdRequest): ResolvedFormDataServiceGetByTaskIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolvedFormDataServiceGetByTaskIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest
 */
export const ResolvedFormDataServiceGetByTaskIdRequest = new ResolvedFormDataServiceGetByTaskIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFormDataServiceGetByTaskIdResponse$Type extends MessageType<ResolvedFormDataServiceGetByTaskIdResponse> {
    constructor() {
        super("c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse", [
            { no: 1, name: "resolved_form_data", kind: "message", T: () => ResolvedFormData, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ResolvedFormDataServiceGetByTaskIdResponse>): ResolvedFormDataServiceGetByTaskIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ResolvedFormDataServiceGetByTaskIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolvedFormDataServiceGetByTaskIdResponse): ResolvedFormDataServiceGetByTaskIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.ResolvedFormData resolved_form_data */ 1:
                    message.resolvedFormData = ResolvedFormData.internalBinaryRead(reader, reader.uint32(), options, message.resolvedFormData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolvedFormDataServiceGetByTaskIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.ResolvedFormData resolved_form_data = 1; */
        if (message.resolvedFormData)
            ResolvedFormData.internalBinaryWrite(message.resolvedFormData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse
 */
export const ResolvedFormDataServiceGetByTaskIdResponse = new ResolvedFormDataServiceGetByTaskIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFormData$Type extends MessageType<ResolvedFormData> {
    constructor() {
        super("c1.api.task.v1.ResolvedFormData", [
            { no: 1, name: "form", kind: "message", T: () => Form, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "resolved_values", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ResolvedFormData>): ResolvedFormData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ResolvedFormData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolvedFormData): ResolvedFormData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.Form form */ 1:
                    message.form = Form.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                case /* google.protobuf.Struct resolved_values */ 2:
                    message.resolvedValues = Struct.internalBinaryRead(reader, reader.uint32(), options, message.resolvedValues);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolvedFormData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.Form form = 1; */
        if (message.form)
            Form.internalBinaryWrite(message.form, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct resolved_values = 2; */
        if (message.resolvedValues)
            Struct.internalBinaryWrite(message.resolvedValues, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ResolvedFormData
 */
export const ResolvedFormData = new ResolvedFormData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceSendReminderResponse$Type extends MessageType<TaskServiceSendReminderResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceSendReminderResponse", []);
    }
    create(value?: PartialMessage<TaskServiceSendReminderResponse>): TaskServiceSendReminderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskServiceSendReminderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceSendReminderResponse): TaskServiceSendReminderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceSendReminderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceSendReminderResponse
 */
export const TaskServiceSendReminderResponse = new TaskServiceSendReminderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceDeleteResponse$Type extends MessageType<TaskServiceDeleteResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceDeleteResponse", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskServiceDeleteResponse>): TaskServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskServiceDeleteResponse): TaskServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceDeleteResponse
 */
export const TaskServiceDeleteResponse = new TaskServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskType$Type extends MessageType<TaskType> {
    constructor() {
        super("c1.api.task.v1.TaskType", [
            { no: 1, name: "grant", kind: "message", oneof: "taskType", T: () => TaskTypeGrant },
            { no: 2, name: "revoke", kind: "message", oneof: "taskType", T: () => TaskTypeRevoke },
            { no: 3, name: "certify", kind: "message", oneof: "taskType", T: () => TaskTypeCertify },
            { no: 4, name: "offboarding", kind: "message", oneof: "taskType", T: () => TaskTypeOffboarding },
            { no: 5, name: "action", kind: "message", oneof: "taskType", T: () => TaskTypeAction }
        ]);
    }
    create(value?: PartialMessage<TaskType>): TaskType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskType = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<TaskType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskType): TaskType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskTypeGrant grant */ 1:
                    message.taskType = {
                        oneofKind: "grant",
                        grant: TaskTypeGrant.internalBinaryRead(reader, reader.uint32(), options, (message.taskType as any).grant)
                    };
                    break;
                case /* c1.api.task.v1.TaskTypeRevoke revoke */ 2:
                    message.taskType = {
                        oneofKind: "revoke",
                        revoke: TaskTypeRevoke.internalBinaryRead(reader, reader.uint32(), options, (message.taskType as any).revoke)
                    };
                    break;
                case /* c1.api.task.v1.TaskTypeCertify certify */ 3:
                    message.taskType = {
                        oneofKind: "certify",
                        certify: TaskTypeCertify.internalBinaryRead(reader, reader.uint32(), options, (message.taskType as any).certify)
                    };
                    break;
                case /* c1.api.task.v1.TaskTypeOffboarding offboarding */ 4:
                    message.taskType = {
                        oneofKind: "offboarding",
                        offboarding: TaskTypeOffboarding.internalBinaryRead(reader, reader.uint32(), options, (message.taskType as any).offboarding)
                    };
                    break;
                case /* c1.api.task.v1.TaskTypeAction action */ 5:
                    message.taskType = {
                        oneofKind: "action",
                        action: TaskTypeAction.internalBinaryRead(reader, reader.uint32(), options, (message.taskType as any).action)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskTypeGrant grant = 1; */
        if (message.taskType.oneofKind === "grant")
            TaskTypeGrant.internalBinaryWrite(message.taskType.grant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskTypeRevoke revoke = 2; */
        if (message.taskType.oneofKind === "revoke")
            TaskTypeRevoke.internalBinaryWrite(message.taskType.revoke, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskTypeCertify certify = 3; */
        if (message.taskType.oneofKind === "certify")
            TaskTypeCertify.internalBinaryWrite(message.taskType.certify, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskTypeOffboarding offboarding = 4; */
        if (message.taskType.oneofKind === "offboarding")
            TaskTypeOffboarding.internalBinaryWrite(message.taskType.offboarding, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskTypeAction action = 5; */
        if (message.taskType.oneofKind === "action")
            TaskTypeAction.internalBinaryWrite(message.taskType.action, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskType
 */
export const TaskType = new TaskType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeAction$Type extends MessageType<TaskTypeAction> {
    constructor() {
        super("c1.api.task.v1.TaskTypeAction", [
            { no: 1, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "form_values", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.ActionOutcome", ActionOutcome, "ACTION_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskTypeAction>): TaskTypeAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actionId = "";
        message.outcome = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskTypeAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskTypeAction): TaskTypeAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string action_id */ 1:
                    message.actionId = reader.string();
                    break;
                case /* google.protobuf.Struct form_values */ 2:
                    message.formValues = Struct.internalBinaryRead(reader, reader.uint32(), options, message.formValues);
                    break;
                case /* c1.api.task.v1.ActionOutcome outcome */ 3:
                    message.outcome = reader.int32();
                    break;
                case /* google.protobuf.Timestamp outcome_time */ 4:
                    message.outcomeTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskTypeAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string action_id = 1; */
        if (message.actionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actionId);
        /* google.protobuf.Struct form_values = 2; */
        if (message.formValues)
            Struct.internalBinaryWrite(message.formValues, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.ActionOutcome outcome = 3; */
        if (message.outcome !== 0)
            writer.tag(3, WireType.Varint).int32(message.outcome);
        /* google.protobuf.Timestamp outcome_time = 4; */
        if (message.outcomeTime)
            Timestamp.internalBinaryWrite(message.outcomeTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeAction
 */
export const TaskTypeAction = new TaskTypeAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeOffboarding$Type extends MessageType<TaskTypeOffboarding> {
    constructor() {
        super("c1.api.task.v1.TaskTypeOffboarding", [
            { no: 1, name: "subject_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.OffboardingOutcome", OffboardingOutcome, "OFFBOARDING_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskTypeOffboarding>): TaskTypeOffboarding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subjectUserId = "";
        message.outcome = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskTypeOffboarding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskTypeOffboarding): TaskTypeOffboarding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject_user_id */ 1:
                    message.subjectUserId = reader.string();
                    break;
                case /* c1.api.task.v1.OffboardingOutcome outcome */ 2:
                    message.outcome = reader.int32();
                    break;
                case /* google.protobuf.Timestamp outcome_time */ 3:
                    message.outcomeTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskTypeOffboarding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject_user_id = 1; */
        if (message.subjectUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subjectUserId);
        /* c1.api.task.v1.OffboardingOutcome outcome = 2; */
        if (message.outcome !== 0)
            writer.tag(2, WireType.Varint).int32(message.outcome);
        /* google.protobuf.Timestamp outcome_time = 3; */
        if (message.outcomeTime)
            Timestamp.internalBinaryWrite(message.outcomeTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeOffboarding
 */
export const TaskTypeOffboarding = new TaskTypeOffboarding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeGrant$Type extends MessageType<TaskTypeGrant> {
    constructor() {
        super("c1.api.task.v1.TaskTypeGrant", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "grant_duration", kind: "message", T: () => Duration, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.GrantOutcome", GrantOutcome, "GRANT_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "source", kind: "message", T: () => TaskGrantSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskTypeGrant>): TaskTypeGrant {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.appEntitlementId = "";
        message.outcome = 0;
        message.identityUserId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskTypeGrant>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskTypeGrant): TaskTypeGrant {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* google.protobuf.Duration grant_duration */ 4:
                    message.grantDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.grantDuration);
                    break;
                case /* c1.api.task.v1.GrantOutcome outcome */ 5:
                    message.outcome = reader.int32();
                    break;
                case /* google.protobuf.Timestamp outcome_time */ 6:
                    message.outcomeTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeTime);
                    break;
                case /* string identity_user_id */ 7:
                    message.identityUserId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskGrantSource source */ 8:
                    message.source = TaskGrantSource.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskTypeGrant, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* google.protobuf.Duration grant_duration = 4; */
        if (message.grantDuration)
            Duration.internalBinaryWrite(message.grantDuration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.GrantOutcome outcome = 5; */
        if (message.outcome !== 0)
            writer.tag(5, WireType.Varint).int32(message.outcome);
        /* google.protobuf.Timestamp outcome_time = 6; */
        if (message.outcomeTime)
            Timestamp.internalBinaryWrite(message.outcomeTime, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_id = 7; */
        if (message.identityUserId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.identityUserId);
        /* c1.api.task.v1.TaskGrantSource source = 8; */
        if (message.source)
            TaskGrantSource.internalBinaryWrite(message.source, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeGrant
 */
export const TaskTypeGrant = new TaskTypeGrant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskGrantSource$Type extends MessageType<TaskGrantSource> {
    constructor() {
        super("c1.api.task.v1.TaskGrantSource", [
            { no: 1, name: "integration_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_extension", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TaskGrantSource>): TaskGrantSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationId = "";
        message.externalUrl = "";
        message.requestId = "";
        message.conversationId = "";
        message.isExtension = false;
        if (value !== undefined)
            reflectionMergePartial<TaskGrantSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskGrantSource): TaskGrantSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string integration_id */ 1:
                    message.integrationId = reader.string();
                    break;
                case /* string external_url */ 2:
                    message.externalUrl = reader.string();
                    break;
                case /* string request_id */ 3:
                    message.requestId = reader.string();
                    break;
                case /* string conversation_id */ 4:
                    message.conversationId = reader.string();
                    break;
                case /* bool is_extension */ 5:
                    message.isExtension = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskGrantSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string integration_id = 1; */
        if (message.integrationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.integrationId);
        /* string external_url = 2; */
        if (message.externalUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalUrl);
        /* string request_id = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* string conversation_id = 4; */
        if (message.conversationId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.conversationId);
        /* bool is_extension = 5; */
        if (message.isExtension !== false)
            writer.tag(5, WireType.Varint).bool(message.isExtension);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskGrantSource
 */
export const TaskGrantSource = new TaskGrantSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceReview$Type extends MessageType<TaskRevokeSourceReview> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceReview", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cert_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskRevokeSourceReview>): TaskRevokeSourceReview {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.certTicketId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskRevokeSourceReview>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskRevokeSourceReview): TaskRevokeSourceReview {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string cert_ticket_id */ 2:
                    message.certTicketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskRevokeSourceReview, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string cert_ticket_id = 2; */
        if (message.certTicketId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.certTicketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceReview
 */
export const TaskRevokeSourceReview = new TaskRevokeSourceReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceRequest$Type extends MessageType<TaskRevokeSourceRequest> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceRequest", [
            { no: 1, name: "request_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskRevokeSourceRequest>): TaskRevokeSourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestUserId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskRevokeSourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskRevokeSourceRequest): TaskRevokeSourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_user_id */ 1:
                    message.requestUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskRevokeSourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_user_id = 1; */
        if (message.requestUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceRequest
 */
export const TaskRevokeSourceRequest = new TaskRevokeSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceExpired$Type extends MessageType<TaskRevokeSourceExpired> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceExpired", [
            { no: 1, name: "expired_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskRevokeSourceExpired>): TaskRevokeSourceExpired {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskRevokeSourceExpired>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskRevokeSourceExpired): TaskRevokeSourceExpired {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp expired_at */ 1:
                    message.expiredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskRevokeSourceExpired, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp expired_at = 1; */
        if (message.expiredAt)
            Timestamp.internalBinaryWrite(message.expiredAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceExpired
 */
export const TaskRevokeSourceExpired = new TaskRevokeSourceExpired$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceNonUsage$Type extends MessageType<TaskRevokeSourceNonUsage> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceNonUsage", [
            { no: 1, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "last_login", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskRevokeSourceNonUsage>): TaskRevokeSourceNonUsage {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskRevokeSourceNonUsage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskRevokeSourceNonUsage): TaskRevokeSourceNonUsage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp expires_at */ 1:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* google.protobuf.Timestamp last_login */ 2:
                    message.lastLogin = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastLogin);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskRevokeSourceNonUsage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp expires_at = 1; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_login = 2; */
        if (message.lastLogin)
            Timestamp.internalBinaryWrite(message.lastLogin, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceNonUsage
 */
export const TaskRevokeSourceNonUsage = new TaskRevokeSourceNonUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSource$Type extends MessageType<TaskRevokeSource> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSource", [
            { no: 1, name: "review", kind: "message", oneof: "origin", T: () => TaskRevokeSourceReview },
            { no: 2, name: "request", kind: "message", oneof: "origin", T: () => TaskRevokeSourceRequest },
            { no: 3, name: "expired", kind: "message", oneof: "origin", T: () => TaskRevokeSourceExpired },
            { no: 4, name: "non_usage", kind: "message", oneof: "origin", T: () => TaskRevokeSourceNonUsage }
        ]);
    }
    create(value?: PartialMessage<TaskRevokeSource>): TaskRevokeSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.origin = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<TaskRevokeSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskRevokeSource): TaskRevokeSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskRevokeSourceReview review */ 1:
                    message.origin = {
                        oneofKind: "review",
                        review: TaskRevokeSourceReview.internalBinaryRead(reader, reader.uint32(), options, (message.origin as any).review)
                    };
                    break;
                case /* c1.api.task.v1.TaskRevokeSourceRequest request */ 2:
                    message.origin = {
                        oneofKind: "request",
                        request: TaskRevokeSourceRequest.internalBinaryRead(reader, reader.uint32(), options, (message.origin as any).request)
                    };
                    break;
                case /* c1.api.task.v1.TaskRevokeSourceExpired expired */ 3:
                    message.origin = {
                        oneofKind: "expired",
                        expired: TaskRevokeSourceExpired.internalBinaryRead(reader, reader.uint32(), options, (message.origin as any).expired)
                    };
                    break;
                case /* c1.api.task.v1.TaskRevokeSourceNonUsage non_usage */ 4:
                    message.origin = {
                        oneofKind: "nonUsage",
                        nonUsage: TaskRevokeSourceNonUsage.internalBinaryRead(reader, reader.uint32(), options, (message.origin as any).nonUsage)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskRevokeSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskRevokeSourceReview review = 1; */
        if (message.origin.oneofKind === "review")
            TaskRevokeSourceReview.internalBinaryWrite(message.origin.review, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskRevokeSourceRequest request = 2; */
        if (message.origin.oneofKind === "request")
            TaskRevokeSourceRequest.internalBinaryWrite(message.origin.request, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskRevokeSourceExpired expired = 3; */
        if (message.origin.oneofKind === "expired")
            TaskRevokeSourceExpired.internalBinaryWrite(message.origin.expired, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskRevokeSourceNonUsage non_usage = 4; */
        if (message.origin.oneofKind === "nonUsage")
            TaskRevokeSourceNonUsage.internalBinaryWrite(message.origin.nonUsage, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSource
 */
export const TaskRevokeSource = new TaskRevokeSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeRevoke$Type extends MessageType<TaskTypeRevoke> {
    constructor() {
        super("c1.api.task.v1.TaskTypeRevoke", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.RevokeOutcome", RevokeOutcome, "REVOKE_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "source", kind: "message", T: () => TaskRevokeSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskTypeRevoke>): TaskTypeRevoke {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.appEntitlementId = "";
        message.outcome = 0;
        message.identityUserId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskTypeRevoke>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskTypeRevoke): TaskTypeRevoke {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 5:
                    message.appUserId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.task.v1.RevokeOutcome outcome */ 3:
                    message.outcome = reader.int32();
                    break;
                case /* google.protobuf.Timestamp outcome_time */ 4:
                    message.outcomeTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeTime);
                    break;
                case /* string identity_user_id */ 6:
                    message.identityUserId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskRevokeSource source */ 7:
                    message.source = TaskRevokeSource.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskTypeRevoke, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.task.v1.RevokeOutcome outcome = 3; */
        if (message.outcome !== 0)
            writer.tag(3, WireType.Varint).int32(message.outcome);
        /* google.protobuf.Timestamp outcome_time = 4; */
        if (message.outcomeTime)
            Timestamp.internalBinaryWrite(message.outcomeTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_id = 5; */
        if (message.appUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserId);
        /* string identity_user_id = 6; */
        if (message.identityUserId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.identityUserId);
        /* c1.api.task.v1.TaskRevokeSource source = 7; */
        if (message.source)
            TaskRevokeSource.internalBinaryWrite(message.source, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeRevoke
 */
export const TaskTypeRevoke = new TaskTypeRevoke$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeCertify$Type extends MessageType<TaskTypeCertify> {
    constructor() {
        super("c1.api.task.v1.TaskTypeCertify", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "access_review_selection", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.CertifyOutcome", CertifyOutcome, "CERTIFY_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskTypeCertify>): TaskTypeCertify {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.accessReviewId = "";
        message.accessReviewSelection = "";
        message.appUserId = "";
        message.outcome = 0;
        message.identityUserId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskTypeCertify>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskTypeCertify): TaskTypeCertify {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string access_review_id */ 3:
                    message.accessReviewId = reader.string();
                    break;
                case /* string access_review_selection */ 4:
                    message.accessReviewSelection = reader.string();
                    break;
                case /* string app_user_id */ 5:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.task.v1.CertifyOutcome outcome */ 6:
                    message.outcome = reader.int32();
                    break;
                case /* google.protobuf.Timestamp outcome_time */ 7:
                    message.outcomeTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeTime);
                    break;
                case /* string identity_user_id */ 8:
                    message.identityUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskTypeCertify, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string access_review_id = 3; */
        if (message.accessReviewId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewId);
        /* string access_review_selection = 4; */
        if (message.accessReviewSelection !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.accessReviewSelection);
        /* string app_user_id = 5; */
        if (message.appUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.task.v1.CertifyOutcome outcome = 6; */
        if (message.outcome !== 0)
            writer.tag(6, WireType.Varint).int32(message.outcome);
        /* google.protobuf.Timestamp outcome_time = 7; */
        if (message.outcomeTime)
            Timestamp.internalBinaryWrite(message.outcomeTime, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_id = 8; */
        if (message.identityUserId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.identityUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeCertify
 */
export const TaskTypeCertify = new TaskTypeCertify$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalRef$Type extends MessageType<ExternalRef> {
    constructor() {
        super("c1.api.task.v1.ExternalRef", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "external_ref_source", kind: "enum", T: () => ["c1.api.task.v1.ExternalRefSource", ExternalRefSource], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ExternalRef>): ExternalRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.url = "";
        message.name = "";
        message.externalRefSource = 0;
        if (value !== undefined)
            reflectionMergePartial<ExternalRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalRef): ExternalRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* c1.api.task.v1.ExternalRefSource external_ref_source */ 3:
                    message.externalRefSource = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* c1.api.task.v1.ExternalRefSource external_ref_source = 3; */
        if (message.externalRefSource !== 0)
            writer.tag(3, WireType.Varint).int32(message.externalRefSource);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ExternalRef
 */
export const ExternalRef = new ExternalRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskWebhookPayload$Type extends MessageType<TaskWebhookPayload> {
    constructor() {
        super("c1.api.task.v1.TaskWebhookPayload", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TaskWebhookPayload>): TaskWebhookPayload {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<TaskWebhookPayload>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskWebhookPayload): TaskWebhookPayload {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task_view */ 1:
                    message.taskView = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.taskView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskWebhookPayload, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task_view = 1; */
        if (message.taskView)
            TaskView.internalBinaryWrite(message.taskView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskWebhookPayload
 */
export const TaskWebhookPayload = new TaskWebhookPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskView$Type extends MessageType<TaskView> {
    constructor() {
        super("c1.api.task.v1.TaskView", [
            { no: 1, name: "task", kind: "message", T: () => Task, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_by_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "entitlements_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "access_review_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "step_approvers_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "approvers_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "insights_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "app_user_last_usage_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskView>): TaskView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userPath = "";
        message.createdByUserPath = "";
        message.appPath = "";
        message.entitlementsPath = "";
        message.accessReviewPath = "";
        message.appUserPath = "";
        message.stepApproversPath = "";
        message.identityUserPath = "";
        message.insightsPath = "";
        message.appUserLastUsagePath = "";
        if (value !== undefined)
            reflectionMergePartial<TaskView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskView): TaskView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.Task task */ 1:
                    message.task = Task.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                case /* string user_path */ 2:
                    message.userPath = reader.string();
                    break;
                case /* string created_by_user_path */ 3:
                    message.createdByUserPath = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                case /* string entitlements_path */ 5:
                    message.entitlementsPath = reader.string();
                    break;
                case /* string access_review_path */ 6:
                    message.accessReviewPath = reader.string();
                    break;
                case /* string app_user_path */ 7:
                    message.appUserPath = reader.string();
                    break;
                case /* string step_approvers_path */ 8:
                    message.stepApproversPath = reader.string();
                    break;
                case /* string identity_user_path */ 9:
                    message.identityUserPath = reader.string();
                    break;
                case /* string insights_path */ 10:
                    message.insightsPath = reader.string();
                    break;
                case /* string app_user_last_usage_path */ 11:
                    message.appUserLastUsagePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.Task task = 1; */
        if (message.task)
            Task.internalBinaryWrite(message.task, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_path = 2; */
        if (message.userPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userPath);
        /* string created_by_user_path = 3; */
        if (message.createdByUserPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.createdByUserPath);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        /* string entitlements_path = 5; */
        if (message.entitlementsPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.entitlementsPath);
        /* string access_review_path = 6; */
        if (message.accessReviewPath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.accessReviewPath);
        /* string app_user_path = 7; */
        if (message.appUserPath !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appUserPath);
        /* string step_approvers_path = 8; */
        if (message.stepApproversPath !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.stepApproversPath);
        /* string identity_user_path = 9; */
        if (message.identityUserPath !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.identityUserPath);
        /* string insights_path = 10; */
        if (message.insightsPath !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.insightsPath);
        /* string app_user_last_usage_path = 11; */
        if (message.appUserLastUsagePath !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.appUserLastUsagePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskView
 */
export const TaskView = new TaskView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRef$Type extends MessageType<TaskRef> {
    constructor() {
        super("c1.api.task.v1.TaskRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskRef>): TaskRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<TaskRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskRef): TaskRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRef
 */
export const TaskRef = new TaskRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantOrRevokeTaskRef$Type extends MessageType<GrantOrRevokeTaskRef> {
    constructor() {
        super("c1.api.task.v1.GrantOrRevokeTaskRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GrantOrRevokeTaskRef>): GrantOrRevokeTaskRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GrantOrRevokeTaskRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantOrRevokeTaskRef): GrantOrRevokeTaskRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantOrRevokeTaskRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GrantOrRevokeTaskRef
 */
export const GrantOrRevokeTaskRef = new GrantOrRevokeTaskRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskCountRefreshRef$Type extends MessageType<TaskCountRefreshRef> {
    constructor() {
        super("c1.api.task.v1.TaskCountRefreshRef", []);
    }
    create(value?: PartialMessage<TaskCountRefreshRef>): TaskCountRefreshRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskCountRefreshRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskCountRefreshRef): TaskCountRefreshRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskCountRefreshRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskCountRefreshRef
 */
export const TaskCountRefreshRef = new TaskCountRefreshRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Task$Type extends MessageType<Task> {
    constructor() {
        super("c1.api.task.v1.Task", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "created_by_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 18, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 19, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "type", kind: "message", T: () => TaskType, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "policy", kind: "message", T: () => PolicyInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "actions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.TaskActionType", TaskActionType, "TASK_ACTION_TYPE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "external_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalRef, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "analysis_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "step_approver_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 28, name: "approver_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 16, name: "comment_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 17, name: "numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 20, name: "processing", kind: "enum", T: () => ["c1.api.task.v1.TaskProcessingType", TaskProcessingType, "TASK_PROCESSING_TYPE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 21, name: "emergency_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 22, name: "policy_generation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 23, name: "insight_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "recommendation", kind: "enum", T: () => ["c1.api.task.v1.InsightRecommendation", InsightRecommendation, "INSIGHT_RECOMMENDATION_"] },
            { no: 25, name: "origin", kind: "enum", T: () => ["c1.api.task.v1.TaskOrigin", TaskOrigin, "TASK_ORIGIN_"] },
            { no: 26, name: "form", kind: "message", T: () => Form, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 27, name: "data", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<Task>): Task {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.userId = "";
        message.createdByUserId = "";
        message.state = 0;
        message.actions = [];
        message.externalRefs = [];
        message.annotations = [];
        message.analysisId = "";
        message.stepApproverIds = [];
        message.commentCount = 0;
        message.numericId = 0;
        message.processing = 0;
        message.emergencyAccess = false;
        message.policyGenerationId = "";
        message.insightIds = [];
        message.recommendation = 0;
        message.origin = 0;
        if (value !== undefined)
            reflectionMergePartial<Task>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Task): Task {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                case /* string created_by_user_id */ 5:
                    message.createdByUserId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskState state */ 6:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 18:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 19:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.task.v1.TaskType type */ 9:
                    message.type = TaskType.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                case /* c1.api.policy.v1.PolicyInstance policy */ 10:
                    message.policy = PolicyInstance.internalBinaryRead(reader, reader.uint32(), options, message.policy);
                    break;
                case /* repeated c1.api.task.v1.TaskActionType actions */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.actions.push(reader.int32());
                    else
                        message.actions.push(reader.int32());
                    break;
                case /* repeated c1.api.task.v1.ExternalRef external_refs */ 12:
                    message.externalRefs.push(ExternalRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any annotations */ 13:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string analysis_id */ 14:
                    message.analysisId = reader.string();
                    break;
                case /* repeated string step_approver_ids */ 15:
                    message.stepApproverIds.push(reader.string());
                    break;
                case /* int32 comment_count */ 16:
                    message.commentCount = reader.int32();
                    break;
                case /* int64 numeric_id */ 17:
                    message.numericId = reader.int64().toNumber();
                    break;
                case /* c1.api.task.v1.TaskProcessingType processing */ 20:
                    message.processing = reader.int32();
                    break;
                case /* bool emergency_access */ 21:
                    message.emergencyAccess = reader.bool();
                    break;
                case /* string policy_generation_id */ 22:
                    message.policyGenerationId = reader.string();
                    break;
                case /* repeated string insight_ids */ 23:
                    message.insightIds.push(reader.string());
                    break;
                case /* c1.api.task.v1.InsightRecommendation recommendation */ 24:
                    message.recommendation = reader.int32();
                    break;
                case /* c1.api.task.v1.TaskOrigin origin */ 25:
                    message.origin = reader.int32();
                    break;
                case /* c1.api.form.v1.Form form */ 26:
                    message.form = Form.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                case /* google.protobuf.Struct data */ 27:
                    message.data = Struct.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Task, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        /* string created_by_user_id = 5; */
        if (message.createdByUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdByUserId);
        /* c1.api.task.v1.TaskState state = 6; */
        if (message.state !== 0)
            writer.tag(6, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskType type = 9; */
        if (message.type)
            TaskType.internalBinaryWrite(message.type, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.PolicyInstance policy = 10; */
        if (message.policy)
            PolicyInstance.internalBinaryWrite(message.policy, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.TaskActionType actions = 11; */
        if (message.actions.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.actions.length; i++)
                writer.int32(message.actions[i]);
            writer.join();
        }
        /* repeated c1.api.task.v1.ExternalRef external_refs = 12; */
        for (let i = 0; i < message.externalRefs.length; i++)
            ExternalRef.internalBinaryWrite(message.externalRefs[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 13; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string analysis_id = 14; */
        if (message.analysisId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.analysisId);
        /* repeated string step_approver_ids = 15; */
        for (let i = 0; i < message.stepApproverIds.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.stepApproverIds[i]);
        /* int32 comment_count = 16; */
        if (message.commentCount !== 0)
            writer.tag(16, WireType.Varint).int32(message.commentCount);
        /* int64 numeric_id = 17; */
        if (message.numericId !== 0)
            writer.tag(17, WireType.Varint).int64(message.numericId);
        /* google.protobuf.Timestamp updated_at = 18; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 19; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskProcessingType processing = 20; */
        if (message.processing !== 0)
            writer.tag(20, WireType.Varint).int32(message.processing);
        /* bool emergency_access = 21; */
        if (message.emergencyAccess !== false)
            writer.tag(21, WireType.Varint).bool(message.emergencyAccess);
        /* string policy_generation_id = 22; */
        if (message.policyGenerationId !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.policyGenerationId);
        /* repeated string insight_ids = 23; */
        for (let i = 0; i < message.insightIds.length; i++)
            writer.tag(23, WireType.LengthDelimited).string(message.insightIds[i]);
        /* c1.api.task.v1.InsightRecommendation recommendation = 24; */
        if (message.recommendation !== 0)
            writer.tag(24, WireType.Varint).int32(message.recommendation);
        /* c1.api.task.v1.TaskOrigin origin = 25; */
        if (message.origin !== 0)
            writer.tag(25, WireType.Varint).int32(message.origin);
        /* c1.api.form.v1.Form form = 26; */
        if (message.form)
            Form.internalBinaryWrite(message.form, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct data = 27; */
        if (message.data)
            Struct.internalBinaryWrite(message.data, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.Task
 */
export const Task = new Task$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListByUserRequest$Type extends MessageType<ListByUserRequest> {
    constructor() {
        super("c1.api.task.v1.ListByUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListByUserRequest>): ListByUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<ListByUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListByUserRequest): ListByUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListByUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListByUserRequest
 */
export const ListByUserRequest = new ListByUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestartTaskWorkflowRequest$Type extends MessageType<RestartTaskWorkflowRequest> {
    constructor() {
        super("c1.api.task.v1.RestartTaskWorkflowRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RestartTaskWorkflowRequest>): RestartTaskWorkflowRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        if (value !== undefined)
            reflectionMergePartial<RestartTaskWorkflowRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestartTaskWorkflowRequest): RestartTaskWorkflowRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestartTaskWorkflowRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RestartTaskWorkflowRequest
 */
export const RestartTaskWorkflowRequest = new RestartTaskWorkflowRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestartTaskWorkflowResponse$Type extends MessageType<RestartTaskWorkflowResponse> {
    constructor() {
        super("c1.api.task.v1.RestartTaskWorkflowResponse", []);
    }
    create(value?: PartialMessage<RestartTaskWorkflowResponse>): RestartTaskWorkflowResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RestartTaskWorkflowResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestartTaskWorkflowResponse): RestartTaskWorkflowResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestartTaskWorkflowResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RestartTaskWorkflowResponse
 */
export const RestartTaskWorkflowResponse = new RestartTaskWorkflowResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskService
 */
export const TaskService = new ServiceType("c1.api.task.v1.TaskService", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/tasks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Task", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Task" }] }, "authz.method": { role: "VIEWER" } }, I: TaskServiceGetRequest, O: TaskServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateRequest, O: TaskServiceGetResponse },
    { name: "CreateRevokeTask", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/revoke", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "TaskRevoke" }], group: "Task" }] }, "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateRevokeRequest, O: TaskServiceCreateRevokeResponse },
    { name: "CreateGrantTask", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/grant", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "TaskGrant" }], group: "Task" }] }, "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateGrantRequest, O: TaskServiceCreateGrantResponse },
    { name: "CreateManyGrantTasks", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateManyGrantTasksRequest, O: TaskServiceListResponse },
    { name: "CreateOffboardingTask", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/offboarding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "TaskOffboarding" }], group: "Task" }] }, "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateOffboardingRequest, O: TaskServiceCreateOffboardingResponse },
    { name: "CreateActionTask", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateActionRequest, O: TaskServiceCreateActionResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceUpdateRequest, O: TaskServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: TaskServiceListRequest, O: TaskServiceListResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" } }, I: TaskServiceDeleteRequest, O: TaskServiceDeleteResponse },
    { name: "GetSendReminderPreview", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceGetSendReminderPreviewRequest, O: TaskServiceGetSendReminderPreviewResponse },
    { name: "SendReminder", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceSendReminderRequest, O: TaskServiceSendReminderResponse },
    { name: "GetByTaskId", options: { "authz.method": { role: "VIEWER" } }, I: ResolvedFormDataServiceGetByTaskIdRequest, O: ResolvedFormDataServiceGetByTaskIdResponse }
]);
